import API from '../dataApi';

// -- Address Book -----------------------------------------------------------
export const getAddressBookList = (derasarId, memberId) => API.get('/address-book/list', {
  params: { derasarId, ...(memberId ? { memberId } : {}) },
});
export const getAddressBook = (derasarId) => API.get('/address-book', { params: { derasarId } });
export const getPendingAddresses = (derasarId) => API.get('/address-book/pending', { params: { derasarId } });
export const createAddressBookEntry = (data) => API.post('/address-book', data);
export const updateAddressBookEntry = (id, data) => API.put(`/address-book/${id}`, data);
export const deleteAddressBookEntry = (id) => API.delete(`/address-book/${id}`);
export const approveAddressBookEntry = (personId, data) => API.post(`/address-book/approve/${personId}`, data);
